export const sortOptions = [
    { value: "default", label: "Default" },
    { value: "arrival", label: "Arrival date" },
    { value: "name", label: "Name (A-Z)" },
    { value: "species", label: "Species (A-Z)" },
];
export const sortMethods = sortOptions.map((opt) => opt.value);
/**
 * Sorts an array of ambassador entries based on the specified sort method.
 * @param ambassadors - Array of [key, ambassador] tuples
 * @param sortMethod - The sorting method to apply
 * @param sortPartialDates - Function to sort partial dates (for arrival sorting)
 * @returns Sorted array of ambassador entries
 */
export const sortAmbassadors = (ambassadors, sortMethod, sortPartialDates) => {
    switch (sortMethod) {
        case "arrival":
            return [...ambassadors].sort(([, a], [, b]) => sortPartialDates(a.arrival, b.arrival));
        case "name":
            return [...ambassadors].sort(([, a], [, b]) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
        case "species":
            return [...ambassadors].sort(([, a], [, b]) => a.species.name.localeCompare(b.species.name, undefined, {
                sensitivity: "base",
            }));
        case "default":
        default:
            return ambassadors;
    }
};
export default sortOptions;
